export default {"src":"/_next/static/media/whatshot.5d75ce9d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};